export default {
  search: 'جستجو',
  searchHint: 'جستجو با نام / شماره تلفن / ایمیل',
  blocked: 'مسدود شده',
  userId: 'شناسه',
  phone: 'تلفن',
  email: 'ایمیل',
  name: 'نام',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  password: 'کلمه عبور',
  active2fa: '2FA',
  enabled: 'فعال',
  unblock: 'رفع مسدودی',
  save: 'ذخیره',
  securityLogs: 'رخدادهای امنیتی',
  details: 'مشخصات',
  ipaddress: 'ip address',
  date: 'زمان',
  actor: 'کاربر عامل رخداد',
  type: 'نوع',
  level: 'سطح',
  description: 'توضیح',
  ip: 'ip',
  accessLogs: 'تاریخچه فراخوانی',
  appName: 'ماژول',
  endpointPath: 'مسیر',
  statusCode: 'نتیجه',
  userAgent: 'دستگاه',
  responseTime: 'مدت زمان پاسخ',
  module: 'ماژول',
  path: 'تابع',
  validIps: 'ای‌پی های قابل اتصال',
  validIpsPlaceholder: 'like: 294.234.23.42,192.168.*.*',
  timeout: 'مدت زمان معتبر بودن نشست به دقیقه',
  killAllSessions: 'اتمام تمام نشست ‌ها',
  addMemberRole: 'افزودن سمت جدید',
  targetUser: 'کاربر مرتبط',
  status_success: 'موفقیت آمیز',
  status_failed: 'نا موفق',
  status_system_error: 'خطای داخلی سرور',
  status_denied: 'عدم دسترسی',
  Authenticate_Mobile: 'ورود با شماره تلفن',
  TryAuthenticate_Mobile: 'تلاش به ورود با شماره تلفن',
  TryAuthenticate_2fa: 'تلاش به ورود دو مرحله ای ',
  Authenticate_Pass: 'وروود با کلمه عبور',
  Authenticate_2FA: 'ورود دو مرحله ای',
  Authenticate_SAC: 'ورود با کد ورود یک بار مصرف',
  Unsuccessful_Authenticate_Mobile: 'شکست در ورود با شماره تلفن',
  Unsuccessful_Authenticate_Pass: 'شکست در ورود با نام کاربری و کلمه عبور',
  Unsuccessful_Authenticate_2FA: 'ورود دو مرحله ای',
  Unsuccessful_Authenticate_SAC: 'تلاش ناموفق در ورود دو مرحله ای',
  Successful_Registration: 'ثبت نام موفق',
  Unsuccessful_Registration: 'ثبت نام ناموفق',
  Inconsistency: 'خطا در داده های امنیتی ',
  Role_Add: 'اضافه شدن نقش به کاربر',
  Role_Remove: 'حذف نقش از کاربر',
  NotifyLogout: 'اعلام خروج کاربر',
  Renew_Token: 'تمدید توکن درتسرس',
  User_Blocked: 'مسدودی کاربر',
  Authorized_Security_Logs: 'دسترسی به رکورد‌های امنیتی ',
  Unauthorized_Security_Logs: 'دسترسی نا موفق به رکورد های امنتی',
  Successful_Config: 'تغییر در تنظیمات',
  Unsuccessful_Config: 'خطا در تغییر تنظیمات',
  Change_Phone: 'تغییر شماره تلفن',
  Change_Password: 'تغییر کلمه عبور',
  User_Deleted: 'حذف کاربر',
  User_Restored: 'بازیابی کاربر',
  User_Enabled: 'فعال سازی کاربر',
  User_Disabled: 'غیر فعال سازی کاربر',
  Enable_2FA: 'فعال سازی ورود دو مرحله ای',
  Disable_2FA: 'غیری فعال سازی ورود دو مرحله ای',
  SecurityEventView: 'مشاهده رخداد های امنیتی',
  LowDiscSpace: 'محدودیت فضای ذخیه سازی',
  KilledAllSessions: 'اتمام نشست‌ها توسط مدیر',
  User_UnBlocked: 'رفع مسدودی حساب',
  ClickHouse_Log: 'دسترسی به تاریخچه فراخوانی',
};
